
import myAxios from '../utils/request.js';

export default {
    // 租户列表
    async getTenantList (params={}, cb) {
        let res = await myAxios.getJson('/system/tenant/list', params);
        return res.data;
    },
    // 新增
    async addTenant (params={}, cb) {
        let res = await myAxios.postJson('/system/tenant', params);
        return res.data;
    },

    // 修改
    async updateTenant (params={}, cb) {
        let res = await myAxios.putJson('/system/tenant', params);
        return res.data;
    },

    // 删除
    async deleteTenant (id, cb) {
        let res = await myAxios.deleteJson('/system/tenant/' + id);
        return res.data;
    },
    // 详情
     async getTenantDetails (id, cb) {
        let res = await myAxios.getJson('/system/tenant/' + id);
        return res.data;
    },
    // 状态修改
    async changeTenantStatus (params={}, cb) {
        let res = await myAxios.putJson('/system/tenant/changeStatus', params);
        return res.data;
    },

    // 同步租户套餐
    async syncTenantPackage (params={}, cb) {
        let res = await myAxios.getJson('/system/tenant/syncTenantPackage', params);
        return res.data;
    },


    // 租户套餐

    async getTenantPackageList (params={}, cb) {
        let res = await myAxios.getJson('/system/tenant/package/list', params);
        return res.data;
    },
    // 新增
    async addTenantPackage (params={}, cb) {
        let res = await myAxios.postJson('/system/tenant/package', params);
        return res.data;
    },

    // 修改
    async updateTenantPackage (params={}, cb) {
        let res = await myAxios.putJson('/system/tenant/package', params);
        return res.data;
    },

    // 删除
    async deleteTenantPackage (packageId, cb) {
        let res = await myAxios.deleteJson('/system/tenant/package/' + packageId);
        return res.data;
    },

    // 详情
    async getTenantPackageDetails (id, cb) {
        let res = await myAxios.getJson('/system/tenant/package/' + id);
        return res.data;
    },
    
    // 状态修改
    async changePackageStatus (params={}, cb) {
        let res = await myAxios.putJson('/system/tenant/package/changeStatus', params);
        return res.data;
    },

    // 查询租户套餐下拉选列表
    async selectTenantPackage (id, cb) {
        let res = await myAxios.getJson('/system/tenant/package/selectList');
        return res.data;
    },

    // 判断是否接入门户 true接入，false未接入
    async getisAccessPortal (id, cb) {
        let res = await myAxios.getJson('/system/tenant/isAccessPortal');
        return res.data;
    },
    // 获取门户租户信息
    async queryPortalTenant (id, cb) {
        let res = await myAxios.getJson('/system/tenant/queryPortalTenant');
        return res.data;
    },
    
}



// 查询租户套餐详细
// export function getTenantPackage(packageId){
//   return request({
//     url: '/system/tenant/package/' + packageId,
//     method: 'get'
//   });
// }
